/* src/app/modules/portal/components/planned-activities-panel/planned-activities-panel.component.scss */
sh-table-cell sh-icon {
  display: inline;
  position: absolute;
  margin-left: 100px;
}
sh-text[size=header-2] {
  margin-bottom: 1rem;
}
sh-table {
  height: initial;
}
:host([widgetmode]) .ticket {
  flex-direction: column;
}
:host([widgetmode]) .ticket .item {
  width: 100%;
}
.ticket-indicator {
  border-left: solid;
  border-left-width: thick;
}
.ticket-indicator[color=yellow] {
  border-color: #ffd201;
}
.ticket-indicator[color=green] {
  border-color: #009a38;
}
.ticket-indicator[color=red] {
  border-color: #e7001d;
}
.ticket {
  box-shadow: none !important;
  padding: initial !important;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
  gap: 1rem;
}
.tickets-mobile {
  gap: 0rem;
  text-wrap: pretty;
}
.empty {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
}
[size=title-1] {
  margin-bottom: 0.5rem;
}
sh-button {
  padding: 10px 15px;
  margin-top: 1rem;
}
sh-table-row:not(:first-child) {
  margin-bottom: 3px;
}
sh-table-cell {
  align-items: baseline;
}
sh-table-cell span {
  margin-top: -5px;
}
.last-overdue {
  margin-bottom: -0.6rem;
  margin-block-start: 0.5rem;
}
.align-empty-activities-text {
  text-align: center;
  white-space: break-spaces;
}
.view-mode-icon {
  margin: 0.5rem 0;
}
.ticket-number-text {
  margin-top: 0.5rem;
}
.button-container {
  display: flex;
  justify-content: flex-end;
}
.activities-button {
  margin-right: 0.3rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
[screen-tablet] :host-context .mobile-devices-flex,
[screen-phone] :host-context .mobile-devices-flex {
  display: flex;
  margin-block-start: 0.5rem;
}
[screen-tablet] :host-context sh-button,
[screen-phone] :host-context sh-button {
  display: flex;
  align-self: flex-end;
}
[screen-tablet] :host-context .button-container,
[screen-phone] :host-context .button-container {
  justify-content: right;
}
[screen-tablet] :host-context .tickets-mobile,
[screen-phone] :host-context .tickets-mobile {
  box-shadow: var(--shadow-raised);
  border-radius: var(--sh-card-border-radius);
}
[screen-tablet] :host-context .last-overdue,
[screen-phone] :host-context .last-overdue {
  margin-block-start: 0.5rem;
}
[screen-tablet] activities-button,
[screen-phone] activities-button {
  margin-top: 0.5rem;
}
/*# sourceMappingURL=planned-activities-panel.component.css.map */
